import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectWindowType = createSelector(selectJsonQuery, jsonQuery => getTermValue('windows_type')(jsonQuery));
